

import GwButton from '~/patterns/atoms/button/button.vue';
import GwIcon from '~/patterns/atoms/icon/icon.vue';
import addVatToText from '~/mixins/addVatToText';

export default {
    components: {
        GwButton,
        GwIcon
    },
    mixins: [addVatToText],
    props: {
        item: {
            type: Object,
            required: true
        },
        participants: {
            type: Array,
            required: true
        },
    },
    data() {
        return {
            currency: this.$config.site.currencies[0],
            selected: false,
            showParticipants: false,
            selectedParticipants: this.participants.map(participant => participant.id)
        };
    },
    computed: {
        price() {
            return this.addCurrency(this.item.prices);
        },
        date() {
            return this.$d(new Date(this.item.start), 'dateFull') || null;
        },
        crossSellPrice() {
            const price = this.getPrice(this.item.prices);
            return Math.ceil((100 - this.item.crossSellPercentage) / 100 * price.price);
        },
        urlHref() {
            return this.item.slug;
        }
    },
    watch: {
        selectedParticipants(value) {
            this.updateEditions('update');
        }
    },
    methods: {
        updateEditions(mode) {
            const newMode = mode ?? (this.selected ? 'remove' : 'add');

            if (newMode !== 'update') {
                this.selected = !this.selected;
                this.showParticipants = false;
            }

            this.$root.$emit('update-editions', newMode, this.item.id, this.selectedParticipants);
        },
        toggleParticipant() {
            this.showParticipants = !this.showParticipants;
        },
        getPrice(prices) {
            return prices.filter(price => price.currency === this.currency)[0];
        },
        addCurrency(prices) {
            const price = this.getPrice(prices);

            const locale = this.$config.site.locale;
            const vatIncluded = false;
            const showVatText = locale === 'fr' && !vatIncluded;
            const exVatText = this.$t('schedule.ex-vat');

            function vat() {
                if (showVatText) {
                    return ` ${exVatText}`;
                } else {
                    return '';
                }
            }

            if (price?.price !== undefined) {
                return `${this.$n(price.price, {
                    style: 'currency',
                    currency: price.currency,
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                })}${vat()}`;
            }
        },
    }
};
